import { render, staticRenderFns } from "./GlobalCompanySettings.vue?vue&type=template&id=56350643&"
import script from "./GlobalCompanySettings.vue?vue&type=script&lang=js&"
export * from "./GlobalCompanySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports